import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 * Synchronizes the theme state with DOM:
 * - Toggles `dark` class on <html> and <body>
 * - Updates the single theme-color meta tag instantly
 * - Directly updates backgroundColor to fix Safari Safe Area glitches
 */
export default function useThemeSync() {
  const isDarkMode = useSelector((state) => state.theme.isDarkMode);

  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    const metaThemeColor = document.getElementById('theme-color-meta');

    const bgColor = isDarkMode ? '#111827' : '#f8fafc';

    if (isDarkMode) {
      root.classList.add('dark');
      body.classList.add('dark');
    } else {
      root.classList.remove('dark');
      body.classList.remove('dark');
    }
    root.style.backgroundColor = bgColor;
    body.style.backgroundColor = bgColor;

    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', bgColor);
    }
  }, [isDarkMode]);
}
